module.exports = __webpack_public_path__ + "img/changshuyh.e02c8b39.png";